import * as XLSX from 'xlsx';

interface IImportacaoDadosRow {
  linha: number;
  status: string;
  erro?: string | null;
  dados?: Record<string, unknown> | null;
}

export function collectDadosColumnKeys(rows: IImportacaoDadosRow[]): string[] {
  const keys: string[] = [];
  const keysSet = new Set<string>();

  rows.forEach((row) => {
    if (!row.dados || typeof row.dados !== 'object') return;
    Object.keys(row.dados).forEach((key) => {
      if (!keysSet.has(key)) {
        keysSet.add(key);
        keys.push(key);
      }
    });
  });

  return keys;
}

export function parseImportacaoDadosRows(rows: IImportacaoDadosRow[]): Record<string, unknown>[] {
  const dadosColumnKeys = collectDadosColumnKeys(rows);

  return rows.map((row) => {
    const flatRow: Record<string, unknown> = {
      Linha: row.linha,
      Status: row.status,
      Erro: row.erro ?? '',
    };
    dadosColumnKeys.forEach((key) => {
      flatRow[key] = row.dados?.[key] ?? null;
    });
    return flatRow;
  });
}

export function createNamedSheetsWorkbook(sheets: { name: string; rows: Record<string, unknown>[] }[]): XLSX.WorkBook {
  const workbook = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), name);
  });
  return workbook;
}

export function createRelatorioWorkbook(
  sinteticoRows: Record<string, unknown>[],
  importacaoRows: IImportacaoDadosRow[],
): XLSX.WorkBook {
  const sinteticoWorksheet = XLSX.utils.json_to_sheet(sinteticoRows);
  const analiticoWorksheet = XLSX.utils.json_to_sheet(parseImportacaoDadosRows(importacaoRows));
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, sinteticoWorksheet, 'Sintético');
  XLSX.utils.book_append_sheet(workbook, analiticoWorksheet, 'Analitico');

  return workbook;
}
